export default "__VITE_ASSET__BNA_k0o3__"